import { render } from "./UserHunting.vue?vue&type=template&id=681a5f30&scoped=true&ts=true"
import script from "./UserHunting.vue?vue&type=script&lang=ts"
export * from "./UserHunting.vue?vue&type=script&lang=ts"

import "./UserHunting.vue?vue&type=style&index=0&id=681a5f30&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-681a5f30"]])

export default __exports__